<template>
  <div class="box-pagination"  v-if="total > 9">
    <div>Résultats {{ startIndex + 1 }} à {{ endIndex }} sur {{ total }}</div>
    <div>
      <el-pagination
          :current-page="currentPage"
          :page-size="pageSize"
          :page-sizes="pageSizes"
          :total="total"
          @current-change="handleCurrentChange"
          layout="prev, pager, next">
      </el-pagination>
    </div>
    <div class="results">
      Résultats par page :
      <a
          v-for="size in pageSizes"
          :key="size"
          class="link-pagination"
          href="#"
          @click.prevent="changePageSize(size)"
      >{{ size }}</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default: () => [5, 10, 30]
    }
  },
  data () {
    return {
      clickedSizes: []
    }
  },
  computed: {
    startIndex () {
      return (this.currentPage - 1) * this.pageSize
    },
    endIndex () {
      return Math.min(this.startIndex + this.pageSize, this.total)
    }
  },
  methods: {
    handleCurrentChange (page) {
      this.$emit('update:currentPage', page)
    },
    changePageSize (size) {
      this.clickedSizes.push(size)
      this.$emit('update:pageSize', size)
    }
  }
}
</script>

<style lang="scss" scoped>
.box-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  color: #3b7280;
  font-size: 12px;
  font-family: Open Sans, Helvetica, Arial, sans-serif;
  font-weight: 400;

  .el-pagination {
    font-weight: 400;
    .el-pager li .number {
      margin: 0;
    }
  }

  .link-pagination {
    margin-right: 10px;
    color: #184a56;
    cursor: pointer;
    text-decoration: underline;
    text-decoration-color: #3eaec9;
    &:hover {
      color: #3eaec9;
      text-decoration: none;
    }
    &:visited{
      color: #184a56;
    }
  }
}
</style>
